import React from 'react';
import MainContent from './MainContent';
import '../assets/css/main.css';

function App() {
  return (
    <>
      <MainContent />
    </>
  );
}

export default App;
